module.exports = __webpack_public_path__ + "media/images/ecommerce/logout-94105be7ad8296b4987de55148433a81.svg";